import { Column, Row } from 'Components/Grid';
import { Button } from 'Components/ui';
import { ButtonForm } from '../styles';
import { ContainerSuccess, TitleContent } from './styles';
import { ReactComponent as SuccessIcon } from '../../../assets/success.svg';

export const FormSuccess = ({
  title,
  labelStartAgain,
  handleStartAgain,
  labelShow = 'Ver detalhes',
  handleShow,
  showButtonStartAgain = true,
  showButtonSeeDetail = true,
}) => {
  return (
    <ContainerSuccess>
      <Row justifyContent="center">
        <Column xs={6}>
          <SuccessIcon width="80px" height="80px" style={{ margin: '0 auto 24px', display: 'flex' }} />
        </Column>
      </Row>
      <Row justifyContent="center">
        <TitleContent justifyContent="center" xs={12}>
          {title}
        </TitleContent>
      </Row>
      <Row justifyContent="around" alignItems="center" noGutters>
        {showButtonStartAgain && (
          <Column xs={6} justifyContent="center" className="d-flex">
            <Button
              variant="outline"
              id="cancel"
              onClick={handleStartAgain}
              className="max-content"
              sx={{ height: '44px', padding: '0 20px' }}
            >
              {labelStartAgain}
            </Button>
          </Column>
        )}
        {showButtonSeeDetail && (
          <Column xs={5} justifyContent="center" className="d-flex">
            <ButtonForm onvariant="button" onClick={handleShow}>{labelShow}</ButtonForm>
          </Column>
        )}
      </Row>
    </ContainerSuccess>
  );
};
